export function safeStringify(object: any) {
  try {
    return JSON.stringify(object);
  } catch {
    return '"Stringify error"';
  }
}
